import { makeObservable, observable, computed } from "mobx";
import type { ImContact } from "@whatslly/types/tuvis-messaging/TuvisMessagingContacts";
import { MessagingContactPhone } from "@whatslly/types/tuvis-messaging/TuvisMessagingContacts";
export class IMContact implements ImContact {
  _id: string;
  orgId: string;
  firstName: string;
  lastName: string;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
  phones: MessagingContactPhone[];

  constructor(data: ImContact) {
    this._id = data._id;
    this.orgId = data.orgId;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.isDeleted = data.isDeleted;
    this.phones = data.phones;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;

    makeObservable(this, {
      firstName: observable,
      lastName: observable,
      isDeleted: observable,
      phones: observable,
      displayName: computed,
    });
  }

  get displayName() {
    return `${this.firstName} ${this.lastName}`.trim();
  }
}
